'use strict';

var callDateGet = require('../../common/internal/callDateGet');

function getYear(d) {
  return callDateGet(d, 'FullYear');
}

module.exports = getYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/getYear.js
// module id = 36
// module chunks = 0